import React, { Component } from "react";
import { Row, Col } from "shards-react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FormGroup, FormControl } from "react-bootstrap";
import { List, Typography, Button } from "antd";
import mailConfigService from "../../../../api/MailConfig/MailConfigService";
export default class MailConfiguration extends Component {
  constructor(props) {
    super(props);

    this.state = {
      applicationEmail: null,
      applicationEmailList: [],
      benefitEmail: null,
      benefitEmailList: [],
      employeeDataEmail: null,
      employeeDataEmailList: [],
    };

    this.handleEvent = this.handleEvent.bind(this);
  }

  componentDidMount() {
    mailConfigService
      .getAllMailConfigs()
      .then((result) => {
        console.log(result.data[0]);
        this.setState({
          applicationEmailList: result.data[0].applicationList,
          benefitEmailList: result.data[0].benefitList,
          employeeDataEmailList: result.data[0].employeeDataList,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.name !== this.state.name) {
      this.handler();
    }
  }

  componentWillUnmount() {}

  // Prototype methods, Bind in Constructor (ES2015)
  handleEvent() {}

  // Class Properties (Stage 3 Proposal)
  handler = () => {
    this.setState();
  };

  onApplicationEmailChange = (e) => {
    this.setState({ applicationEmail: e.target.value });
  };
  onBenefitEmailChange = (e) => {
    this.setState({ benefitEmail: e.target.value });
  };
  onEmployeeDataEmailChange = (e) => {
    this.setState({ employeeDataEmail: e.target.value });
  };

  addingEmailList = (type, selectedField) => {
    let config = this.state[type];
    config.push(selectedField);
    this.setState({ [type]: config });
    console.log(this.state[type]);
  };

  removeItem = (type, index) => {
    let config = this.state[type];
    if (index > -1) {
      config.splice(index, 1);
    }
    this.setState({ [type]: config });
  };

  onButtonClick = () => {
    mailConfigService.addMailConfig({
      applicationList: this.state.applicationEmailList,
      benefitList: this.state.benefitEmailList,
      employeeDataList: this.state.employeeDataEmailList,
    });
    toast.success(`Mail Configuration Created Successfully`, {
      position: toast.POSITION.TOP_CENTER,
    });
    this.setState({
      applicationEmailList: [],
      benefitEmailList: [],
      employeeDataEmailList: [],
      applicationEmail: null,
      benefitEmail: null,
      employeeDataEmail: null,
    });
  };

  render() {
    return (
      <>
        <h5 className="m-0">Mail Configuration</h5>
        <Row form>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>Application Email</label>
              <FormControl
                autoFocus
                type="text"
                name="subject"
                id="subject"
                onChange={this.onApplicationEmailChange.bind(this)}
              />
            </FormGroup>
          </Col>
          <Col
            md="6"
            className="form-group pt-2 align-self-center"
            align="right"
          >
            <Button
              className="btn btn-dark text-white w-25"
              onClick={(e) =>
                this.addingEmailList(
                  "applicationEmailList",
                  this.state.applicationEmail
                )
              }
            >
              Add
            </Button>
          </Col>
          <Col md="12" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>List</label>
              <List
                bordered
                dataSource={this.state.applicationEmailList}
                renderItem={(item, i) => (
                  <List.Item>
                    {item}
                    {"   "}
                    <Button
                      danger
                      type="primary"
                      shape="circle"
                      onClick={() => this.removeItem("applicationEmailList", i)}
                    >
                      X
                    </Button>
                  </List.Item>
                )}
              />
            </FormGroup>
          </Col>
          {/* Benefits List */}
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>Benefits Email</label>
              <FormControl
                autoFocus
                type="text"
                name="subject"
                id="subject"
                onChange={this.onBenefitEmailChange.bind(this)}
              />
            </FormGroup>
          </Col>
          <Col
            md="6"
            className="form-group pt-2 align-self-center"
            align="right"
          >
            <Button
              className="btn btn-dark text-white w-25"
              onClick={(e) =>
                this.addingEmailList(
                  "benefitEmailList",
                  this.state.benefitEmail
                )
              }
            >
              Add
            </Button>
          </Col>
          <Col md="12" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>List</label>
              <List
                bordered
                dataSource={this.state.benefitEmailList}
                renderItem={(item, i) => (
                  <List.Item>
                    {item}
                    {"   "}
                    <Button
                      danger
                      type="primary"
                      shape="circle"
                      onClick={() => this.removeItem("benefitEmailList", i)}
                    >
                      X
                    </Button>
                  </List.Item>
                )}
              />
            </FormGroup>
          </Col>
          {/* Employee Data List */}
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>Employee Data Email</label>
              <FormControl
                autoFocus
                type="text"
                name="subject"
                id="subject"
                onChange={this.onEmployeeDataEmailChange.bind(this)}
              />
            </FormGroup>
          </Col>
          <Col
            md="6"
            className="form-group pt-2 align-self-center"
            align="right"
          >
            <Button
              className="btn btn-dark text-white w-25"
              onClick={(e) =>
                this.addingEmailList(
                  "employeeDataEmailList",
                  this.state.employeeDataEmail
                )
              }
            >
              Add
            </Button>
          </Col>
          <Col md="12" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>List</label>
              <List
                bordered
                dataSource={this.state.employeeDataEmailList}
                renderItem={(item, i) => (
                  <List.Item>
                    {item}
                    {"   "}
                    <Button
                      danger
                      type="primary"
                      shape="circle"
                      onClick={() =>
                        this.removeItem("employeeDataEmailList", i)
                      }
                    >
                      X
                    </Button>
                  </List.Item>
                )}
              />
            </FormGroup>
          </Col>
          <Col
            md="6"
            className="form-group pt-2 align-self-center"
            align="right"
          >
            <Button
              className="btn btn-dark text-white w-25"
              onClick={this.onButtonClick.bind(this)}
            >
              Create
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}
